import { SET_HIGHLIGHT_TO_ITEMS, SET_SCROLL_TO_ITEM } from '../redux/constants';

export const setHighlightToItems =
  (items, scope = 'default') =>
  (dispatch) => {
    dispatch({
      type: SET_HIGHLIGHT_TO_ITEMS,
      scope,
      payload: {
        items,
      },
    });
  };

export const setScrollToItem =
  (scroll, scope = 'default') =>
  (dispatch) => {
    dispatch({
      type: SET_SCROLL_TO_ITEM,
      scope,
      payload: {
        scroll,
      },
    });
  };
